import loader from './loader';
import note from './note';

const filter = document.querySelector('.c-filters__inner');
let unitItems = document.querySelectorAll('.c-filters__group');
const dots = document.querySelector('.c-filters__paged');
const itemsPerPage = window.innerWidth <= 768 ? 1 : 2; // 1 item per page for mobile/tablet, 2 for larger screens

const filters = document.querySelectorAll('.c-filter__inner button');
const ajaxnonce = loschlegal.ajaxnonce;
const ajaxurl = loschlegal.ajaxurl;

const changeItems = (item) => {
    if (item.classList.contains('even')) {
        item.classList.remove('even');
        item.classList.add('odd');
    } else {
        item.classList.remove('odd');
        item.classList.add('even');
    }
};

const centerItems = (item) => {
    item.addEventListener('click', () => {
        if (item.classList.contains('active')) {
            return;
        }

        const itemsHTML = filter.querySelectorAll('.c-filters__group');

        itemsHTML.forEach((item) => {
            item.classList.remove('active');
            changeItems(item);
        });

        item.classList.add('active');
    });
};

// Update the slider to show items for the selected page
const goToPage = (page) => {
    const startIndex = (page - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const itemsHTML = filter.querySelectorAll('.c-filters__group');

    // Fade out current items
    itemsHTML.forEach((item) => {
        item.style.opacity = '0';
    });

    setTimeout(() => {
        itemsHTML.forEach((item, index) => {
            if (index >= startIndex && index < endIndex) {
                item.style.display = 'block'; // Show items for the current page
                item.style.opacity = '1'; // Fade in
            } else {
                item.style.display = 'none'; // Hide other items
            }
        });

        // Update active dot
        const dotsHTML = dots.querySelectorAll('.dot');
        dotsHTML.forEach((dot) => dot.classList.remove('active'));
        dotsHTML[page - 1].classList.add('active');
    }, 300); // Match the CSS transition duration
};


// Initialize pagination
const initializePagination = () => {
    const dotsHTML = dots.querySelectorAll('.dot');
    if (dotsHTML.length > 0) {
        dotsHTML.forEach((dot) => {
            dot.addEventListener('click', () => {
                const page = parseInt(dot.getAttribute('data-page'), 10);
                goToPage(page);
            });
        });

        // Start with the first page
        goToPage(1);
    }
};

// Initialize the slider on page load
if (filter && unitItems) {
    unitItems.forEach((item) => {
        centerItems(item);
    });

    initializePagination();
}

const req = async (data) => {
    try {
        const response = await fetch(ajaxurl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-WP-Nonce': ajaxnonce,
            },
            body: new URLSearchParams(data).toString()
        });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
        }

        const result = await response.json();
        
        const filter = document.querySelector('.c-filters__inner');
        const filterPages = document.querySelector('.c-filters__paged')
        if( filter ) {
            filter.innerHTML = result.html;
        }
        if( filterPages ) {
            filterPages.innerHTML = result.pages;
        }

        const loaderHTML = document.querySelector('.loschlegal-loader');
        if (loaderHTML) loaderHTML.remove();

        // Display a note if provided in the response, otherwise a default message
        // note(response.note || 'Action completed successfully.');
        note(response.note || '');

        filter.querySelectorAll('.c-filters__group').forEach((item) => {
            centerItems(item);
        });
    
        initializePagination();
    } catch (error) {
        console.error('Request error:', error);
        note('It seems there was an error with your request. Please try again later or contact support for assistance.');
    }
};


if( filters) {
    filters.forEach(item => {{
        item.addEventListener('click', () => {
            const term = item.getAttribute('data-term');

            const data = {
                action: `${loschlegal.theme_domain}_users_ajax_request`, // AJAX action
                ajaxnonce: ajaxnonce,
                callback: '_filterByTax',
                term
            }
    
            filter.appendChild(loader())
            req(data)
        })
    }})
}